import { createServerFn, createServerOnlyFn } from "@tanstack/react-start";
import { getCatalog } from "@/lib/core/catalog-core.server";
import { ProviderDetailSchema, ProviderIdSchema } from "./provider.contract";

export const getProviderData = createServerOnlyFn(
    async (providerId: string) => {
        const catalog = await getCatalog();
        const provider = await catalog.organizations.getProviderPage(
            ProviderIdSchema.parse(providerId),
        );
        return provider ? ProviderDetailSchema.parse(provider) : null;
    },
);

export const getProvider = createServerFn({ method: "GET" })
    .inputValidator((providerId: string) => ProviderIdSchema.parse(providerId))
    .handler(async ({ data }) => getProviderData(data));

export async function handleProviderPageRequest(providerId: string) {
    const provider = await getProviderData(providerId);
    return provider
        ? Response.json(provider)
        : Response.json({ error: "Provider not found" }, { status: 404 });
}

export const providerPageApiRoute = {
    server: {
        handlers: {
            GET: ({ params }: { params: { providerId: string } }) =>
                handleProviderPageRequest(params.providerId),
        },
    },
};
